import Amplify from 'aws-amplify'
import awsconfig from '../aws-exports'
import AuthRoute from './AuthRoute'
import LayoutRoute from './LayoutRoute'
import { Switch } from 'react-router-dom'
import React, { Suspense } from 'react'
import { default as Home } from 'views/home/Home'
import { default as Intro } from 'views/intro/Intro'
import { default as NotFound } from 'views/not-found/NotFound'
const Contact = React.lazy(() => import('views/contact/Contact'))
// OR import { default as Contact } from 'views/contact/Contact'
const About = React.lazy(() => import('views/about/About'))
const Rules = React.lazy(() => import('views/rules/Rules'))
const Fight = React.lazy(() => import('views/fight/Fight'))
const List = React.lazy(() => import('views/list/List'))
const MapView = React.lazy(() => import('views/map/Map'))
const Inventory = React.lazy(() => import('views/inventory/Inventory'))
const SkillsView = React.lazy(() => import('views/skills/Skills'))
const Shrine = React.lazy(() => import('views/shrine/Shrine'))
const EventsView = React.lazy(() => import('views/events/EventsView'))
const MessagesView = React.lazy(() => import('views/messages/MessagesView'))
const Clan = React.lazy(() => import('views/clan/Clan'))
const Field = React.lazy(() => import('views/field/Field'))
const Shop = React.lazy(() => import('views/shop/Shop'))
const News = React.lazy(() => import('views/news/News'))
const Signup = React.lazy(() => import('views/signup/Signup'))
const Chat = React.lazy(() => import('views/chat/ChatV'))
const Dojo = React.lazy(() => import('views/dojo/Dojo'))
const Me = React.lazy(() => import('views/me/Me'))
const Logout = React.lazy(() => import('views/logout/Logout'))

// Router reference here: https://reacttraining.com/react-router/web/guides/quick-start

// Configure amplify from export settings
Amplify.configure(awsconfig)

const Routes = () => {
    return (
        <>
            <Switch>
                <LayoutRoute exact path="/" component={Home} />
                <Suspense
                    fallback={
                        <>
                            <progress />
                        </>
                    }
                >
                    <LayoutRoute exact path="/signup" component={Signup} />
                    <LayoutRoute exact path="/contact/" component={Contact} />
                    <LayoutRoute exact path="/about/" component={About} />
                    <LayoutRoute exact path="/intro/" component={Intro} />
                    <LayoutRoute exact path="/rules/" component={Rules} />
                    <LayoutRoute exact path="/news/" component={News} />
                    <LayoutRoute exact path="/map/" component={MapView} />
                    <LayoutRoute exact path="/dojo/" component={Dojo} />
                    <LayoutRoute exact path="/shrine/" component={Shrine} />
                    <LayoutRoute exact path="/fight/" component={Fight} />
                    <LayoutRoute exact path="/ninjas/" component={List} />
                    <LayoutRoute exact path="/logout/" component={Logout} />
                    <AuthRoute exact path="/inventory/" component={Inventory} />
                    <AuthRoute exact path="/skills/" component={SkillsView} />
                    <AuthRoute exact path="/events/" component={EventsView} />
                    <AuthRoute exact path="/messages/" component={MessagesView} />
                    <AuthRoute exact path="/clan/" component={Clan} />
                    <AuthRoute exact path="/field/" component={Field} />
                    <AuthRoute exact path="/shop/" component={Shop} />
                    <AuthRoute exact path="/chat/" component={Chat} />
                    <AuthRoute exact path="/me/" component={Me} />
                </Suspense>
                <LayoutRoute
                    path="*"
                    exact={true}
                    status={404}
                    component={NotFound}
                />
            </Switch>
        </>
    )
}

export default Routes
